import React from "react";

const ProductForm = ({
    scan_code, setScan_code,
    description, setDescription,
    unit_case, setUnit_case,
    department, setDepartment,
    purchase_qty, setPurchase_qty,
    sold_qty, setSold_qty,
    adjust_qty, setAdjust_qty,
    current_qty, setCurrent_qty,
    each_cost, seteach_cost,
    each_retail, seteach_retail,
    onSubmit,
    onReset,
    submitLabel = "Save Product",
    onScanBlur,
}) => {
    return (
        <form onSubmit={onSubmit}>
            <div className="flex justify-between items-center">
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">UPC Scan Code<span className="text-red-500">&nbsp;*</span></span>
                    <input
                        type="text"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Scan a Barcode here"
                        value={scan_code}
                        onChange={(e) => setScan_code(e.target.value)}
                        onBlur={() => onScanBlur && onScanBlur(scan_code)}
                    />
                </div>
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">Department<span className="text-red-500">&nbsp;*</span></span>
                    <input
                        type="text"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Product Department"
                        value={department}
                        onChange={(e) => setDepartment(e.target.value)}
                    />
                </div>
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">Unit/Case</span>
                    <input
                        type="number"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Product Unit or Case"
                        value={unit_case}
                        onChange={(e) => setUnit_case(e.target.value)}
                    />
                </div>
            </div>

            <div className="flex justify-between items-center mt-[1.5vmax]">
                <div className="w-[65.5%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">Description<span className="text-red-500">&nbsp;*</span></span>
                    <input
                        type="text"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Product Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">Purchase Quantity</span>
                    <input
                        type="number"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Product Purchase Quantity"
                        value={purchase_qty}
                        onChange={(e) => setPurchase_qty(e.target.value)}
                    />
                </div>
            </div>

            <div className="flex justify-between items-center mt-[1.5vmax]">
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">Sold Quantity</span>
                    <input
                        type="number"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Product Sold Quantity"
                        value={sold_qty}
                        onChange={(e) => setSold_qty(e.target.value)}
                    />
                </div>
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">Adjust Quantity</span>
                    <input
                        type="number"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Product Adjust Quantity"
                        value={adjust_qty}
                        onChange={(e) => setAdjust_qty(e.target.value)}
                    />
                </div>
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">Current Quantity</span>
                    <input
                        type="number"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Product Current Quantity"
                        value={current_qty}
                        onChange={(e) => setCurrent_qty(e.target.value)}
                    />
                </div>
            </div>

            <div className="flex justify-start gap-[2vmax] items-center mt-[1.5vmax]">
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">
                        Each Cost ($)<span className="text-red-500">&nbsp;*</span>
                    </span>
                    <input
                        type="number"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Each case Cost Price"
                        value={each_cost}
                        onChange={(e) => seteach_cost(e.target.value)}
                    />
                </div>
                <div className="w-[32%] flex flex-col gap-[0.5vmax]">
                    <span className="text-[1vmax] font-[600] text-gray-600">
                        Each Retail ($)<span className="text-red-500">&nbsp;*</span>
                    </span>
                    <input
                        type="number"
                        className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                        placeholder="Each case Retail Price"
                        value={each_retail}
                        onChange={(e) => seteach_retail(e.target.value)}
                    />
                </div>
            </div>

            <div className="flex justify-between gap-[1vmax] mt-10">
                <span className="font-[500] text-gray-600">
                    <i className="fa-solid fa-circle-info"></i>
                    &nbsp;&nbsp;&nbsp;&nbsp;Fields with "<span className="text-red-600"> * </span>" are required
                </span>
                <div className="flex gap-[1.5vmax]">
                    {onReset && (
                        <button
                            className="text-[1.1vmax] bg-gray-500 hover:bg-gray-700 text-white px-[1vmax] py-[0.5vmax] rounded-lg"
                            type="button"
                            onClick={onReset}
                        >
                            Reset
                        </button>
                    )}
                    <button
                        className="text-[1.1vmax] bg-green-600 hover:bg-green-700 text-white px-[1vmax] py-[0.5vmax] rounded-lg"
                        type="submit"
                    >
                        {submitLabel}
                    </button>
                </div>
            </div>
        </form>
    );
};

export default ProductForm;
